module.exports = __webpack_public_path__ + "static/img/kz.9c31d1cb.svg";